import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, Divider, Link } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import SocialLoginButton from './SocialLoginButton';

interface RegisterFormProps {
  onToggleMode: () => void;
}

const RegisterForm: React.FC<RegisterFormProps> = ({ onToggleMode }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const { register } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!username || !email || !password || !confirmPassword) {
      setError('すべての項目を入力してください');
      return;
    }

    if (password !== confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }

    const success = await register(username, email, password);
    if (!success) {
      setError('このユーザー名またはメールアドレスは既に使用されています');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        アカウント登録
      </Typography>
      
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      <TextField
        margin="normal"
        required
        fullWidth
        label="ユーザー名"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        autoFocus
      />
      <TextField
        margin="normal"
        required
        fullWidth
        label="メールアドレス"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        label="パスワード"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        label="パスワード確認"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        登録
      </Button>
      
      <Box sx={{ my: 3 }}>
        <Divider>または</Divider>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
        <SocialLoginButton 
          provider="google" 
          onError={(error) => setError(error)}
        />
      </Box>

      <Button
        fullWidth
        variant="text"
        onClick={onToggleMode}
      >
        既にアカウントをお持ちの方はこちら
      </Button>
      
      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          アカウント作成により、
          <Link href="/privacy-policy" target="_blank" color="primary" sx={{ mx: 0.5 }}>
            プライバシーポリシー
          </Link>
          に同意したものとみなされます。
        </Typography>
      </Box>
    </Box>
  );
};

export default RegisterForm;